export const routeLinks: RouteLinksType = Object.freeze({
    schoolManagement: {
        groupLabel: "School Management",
        url: '',
        visible: true,
        items: {
            dashboard: {
                label: "Dashboard",
                icon: "ri-dashboard-3-line",
                url: "/",
                visible: true,
                new: false,
                children: {},
            },
            schools: {
                label: "Schools",
                icon: "ri-community-line",
                url: "/schools",
                visible: true,
                new: false,
                children: {},
            },
            payments: {
                label: "Payments",
                icon: "ri-wallet-3-line",
                url: "/payments",
                visible: true,
                new: false,
                children: {},
            },
        }
    },
});


export interface RouteLinksType {
    [groupKey: string]: RouteLinksGroupType
}


export interface RouteLinksGroupType {
    groupLabel: string;
    visible: boolean;
    url: string;
    items: {
        [itemKey: string]: LinkItem & {
            children: {
                [childKey: string]: LinkItem
            }
        }
    }
}


interface LinkItem {
    label: string;
    icon: string;
    url: string;
    visible: boolean;
    new: boolean;
}
